import * as React from 'react';
import GenericFormModal from '@/components/form/GenericFormModal';
import { GenericFormGroup } from '@/components/form/GenericForm';
interface OutageFormModalProps {
  visible: boolean
  onDismiss: () => void
  onSubmit: (values: any) => void
  initialValues: any
  title: string
}

function OutageFormModal({
  visible,
  onDismiss,
  onSubmit,
  initialValues,
  title,
}: OutageFormModalProps) {


  const outageFields: GenericFormGroup[] = [{
    groupName: 'main',
    fields: [
      { label: 'Outage Date', name: 'outageDate', type: 'date', required: true, columns: 12, disableFutureDays: true },
      { label: 'Outage Reason', name: 'outageReason', type: 'text', required: true, columns: 12 },
      { label: 'Resolution', name: 'resolution', type: 'text', required: false, columns: 12 },
      { label: 'Resolve Date', name: 'resolveDate', type: 'date', required: false, columns: 12, disableFutureDays: true },
    ]
  }]

  return (
    <>
      <GenericFormModal
        visible={visible}
        onDismiss={onDismiss}
        onSubmit={onSubmit}
        initialValues={initialValues}
        fieldGroups={outageFields}
        title={title}
      />
    </>
  );
}

export default OutageFormModal;
